import axios from "axios";
import API from "./api";

const RAG_API = axios.create({
  baseURL: process.env.REACT_APP_RAG_API_BASE_URL || "/rag",
  timeout: 180000,
});

export const getSystemNotice = async () => {
  try {
    const res = await API.get('/system-notice');
    return res.data?.message || "";
  } catch (err) {
    console.warn("Failed to fetch system notice:", err?.message || err);
    return "";
  }
};

export const setSystemNotice = async (message, token) => {
  const res = await API.post(
    '/system-notice',
    { message },
    { headers: token ? { Authorization: `Bearer ${token}` } : undefined }
  );
  return res.data;
};

export default RAG_API;
